import { useSite } from '../context/SiteContext';
import { bonuses } from '../data/course';
import { asset, toBn } from '../lib/utils';
import { CLOSED_LABEL, discountPercent, taka } from '../lib/price';
import { walletNames } from '../lib/payment';
import { ArrowRightIcon, CheckIcon } from './Icons';

export function SeatBar() {
  const { course } = useSite();
  if (!course.showSeats || !(course.seatsTotal > 0)) return null;

  const left = Math.max(0, course.seatsLeft);
  const filled = Math.min(100, Math.round(((course.seatsTotal - left) / course.seatsTotal) * 100));
  return (
    <div>
      <div className="mb-1.5 flex justify-between text-sm">
        <span className="font-semibold text-red-600">{left > 0 ? `মাত্র ${toBn(left)}টি আসন বাকি!` : 'সব আসন পূর্ণ!'}</span>
        <span className="text-slate-500">{toBn(filled)}% বুকড</span>
      </div>
      <div className="h-2.5 overflow-hidden rounded-full bg-slate-200">
        <div className="h-full rounded-full bg-gradient-to-r from-cta-400 to-red-500" style={{ width: `${filled}%` }} />
      </div>
    </div>
  );
}

export default function Offer() {
  const { course, payment } = useSite();
  const discount = discountPercent(course);
  const included = [
    `${toBn(course.totalClasses)}টি লাইভ MS Excel ক্লাস`,
    'প্রতিটি ক্লাসে লাইভ প্র্যাকটিস ও প্রশ্নোত্তর',
    'অফিসের বাস্তব প্রজেক্ট — Salary Sheet, Result Sheet, Pivot রিপোর্ট',
    `${toBn(course.windowDays)} দিনের মধ্যে পুরো কোর্স সম্পন্ন`,
  ];

  return (
    <section id="offer" className="relative overflow-hidden bg-gradient-to-b from-white to-word-50 py-20">
      <div className="container-x">
        <div className="mx-auto max-w-2xl text-center">
          <span className="eyebrow bg-orange-50 text-cta-600">বিশেষ অফার</span>
          <h2 className="section-title">এক কাপ কফি আর এক বেলা নাস্তার দামে সারাজীবনের দক্ষতা</h2>
        </div>

        <div className="mx-auto mt-12 grid max-w-5xl overflow-hidden rounded-3xl bg-white shadow-2xl shadow-word-900/10 ring-1 ring-slate-900/5 lg:grid-cols-2">
          <div className="p-7 sm:p-10">
            <h3 className="text-xl font-bold text-slate-900">কোর্সে যা যা পাচ্ছেন</h3>
            <ul className="mt-5 space-y-3">
              {included.map((i) => (
                <li key={i} className="flex gap-3 text-slate-700">
                  <CheckIcon className="mt-1 h-5 w-5 shrink-0 text-excel-500" /> {i}
                </li>
              ))}
            </ul>

            {bonuses.length > 0 && (
              <>
                <h3 className="mt-8 flex items-center gap-2 text-xl font-bold text-slate-900">
                  🎁 সাথে {toBn(bonuses.length)}টি বোনাস <span className="rounded bg-excel-100 px-2 py-0.5 text-sm text-excel-700">ফ্রি</span>
                </h3>
                <ul className="mt-5 grid gap-3 sm:grid-cols-2">
                  {bonuses.map((b) => (
                    <li key={b.title} className="rounded-xl border border-dashed border-excel-500/40 bg-excel-50/50 p-3">
                      <div className="font-semibold text-slate-800">
                        {b.icon} {b.title}
                      </div>
                      <div className="mt-0.5 text-sm text-slate-500">{b.desc}</div>
                    </li>
                  ))}
                </ul>
              </>
            )}
          </div>

          <div className="relative flex flex-col justify-center bg-slate-900 p-7 text-center text-white sm:p-10">
            <img src={asset('/images/office-b.jpg')} alt="" className="absolute inset-0 h-full w-full object-cover opacity-15" loading="lazy" />
            {course.enrollmentOpen ? (
              <div className="relative">
                {course.enrollDeadline && (
                  <div className="mx-auto mb-6 inline-block animate-wiggle rounded-full bg-red-500 px-4 py-1 text-sm font-bold">⏳ সীমিত সময়ের অফার</div>
                )}
                {discount && <div className="text-2xl text-slate-400 line-through">{taka(course.regularPrice)}</div>}
                {course.price != null && (
                  <>
                    <div className="text-7xl font-bold text-cta-400">{taka(course.price)}</div>
                    <div className="mt-1 text-slate-300">একবারই পেমেন্ট · কোনো লুকানো খরচ নেই</div>
                  </>
                )}

                <a href="#enroll" className="btn-cta mt-8 w-full">
                  আজই ভর্তি হোন <ArrowRightIcon className="h-5 w-5" />
                </a>
                <p className="mt-3 text-sm text-slate-400">
                  {payment.length ? `${walletNames(payment)}-এ Send Money করে ফর্মে TrxID দিন` : 'ফর্ম পূরণ করুন — আমরাই কল করে বাকিটা জানিয়ে দেব'}
                </p>
              </div>
            ) : (
              <div className="relative py-6">
                <div className="text-5xl">🔒</div>
                <div className="mt-4 text-3xl font-bold">{CLOSED_LABEL}</div>
                <p className="mt-3 text-slate-300">পরবর্তী ব্যাচ শুরু হলে আমাদের Facebook পেজে জানিয়ে দেওয়া হবে।</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
